import Vue from "vue";
import App from "./App.vue";
import vueResource from "vue-resource";
import router from "./routing/router";
import VueMobileDetection from "vue-mobile-detection";
import Vue2TouchEvents from "vue2-touch-events";
import VueMeta from 'vue-meta';


Vue.config.productionTip = false;


Vue.use(VueMeta);
Vue.use(vueResource);
Vue.use(VueMobileDetection);
Vue.use(Vue2TouchEvents);


new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
